export const EnvironmentVariable = {
  localEnvConfig: {
    API_URL: 'https://menupos-be-dev-737182173340.europe-west3.run.app',
    CHAT_BOT_API_URL: 'https://aibackend-737182173340.europe-west1.run.app'
  }
} as const
